/**
 * Names the build-time settings this build is missing. Pure so it can be tested
 * without React Native; `sentry.ts` reports each name to Sentry once per load.
 *
 * The API URL and the Sentry DSN are baked into `constants.ts`. An empty value
 * here means the constant was never filled in for this environment, which
 * would otherwise show up only as a broken sign-in or purchase screen.
 */
export type ConfigSnapshot = {
  environment: string;
  platform: string;
  apiUrl: string | undefined;
  turnstileSiteKey: string | undefined;
  revenueCatKey: string | undefined;
};

/** Platforms whose RevenueCat SDK key this app needs. */
const REVENUECAT_PLATFORMS: readonly string[] = ["ios", "android"];

export function findMissingConfig(config: ConfigSnapshot): string[] {
  // The local stack deliberately leaves these empty.
  if (config.environment === "local") return [];

  const missing: string[] = [];
  if (!config.apiUrl) missing.push("API_URL");
  // The spam check is rendered on the web only.
  if (config.platform === "web" && !config.turnstileSiteKey) {
    missing.push("TURNSTILE_SITE_KEY");
  }
  if (REVENUECAT_PLATFORMS.includes(config.platform) && !config.revenueCatKey) {
    missing.push(`REVENUECAT_API_KEYS.${config.platform}`);
  }
  return missing;
}
